import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { LocationContext } from "../../../CustomHelper/Helper";
import MyVerticallyCenteredModal from "../../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import PaymentModal from "../PaymentModal/PaymentModal";
import PaymentModal1 from "../PaymentModal/PaymentModal1";
import "./CategoryModal.css";

const PackageModal = (props) => {
  const [modalShowPay, setModalShowPay] = React.useState(false);
  const [allPackages, setAllPackage] = useState([]);
  const [userId, setUserId] = useState("");
  const [packageId, setPackageId] = useState("");
  const [packagePrice, setPackagePrice] = useState("");
  const [baseFee, setBasePrice] = useState();

  const [packageBuffer, setPackageBuffer] = useState(true);

  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);

  let fanGroupInfo = props.fanGrpupInfo;
  let walateInfo = props.walateInfo;
  let setFanUserPoints = props.setFanUserPoints;

  const paymentModalStatusFun = (data) => {
    setModalShowPay(data);
    props.packageShowModel(false);
  };

  useEffect(() => {
    axios.get(`/api/user/packages/all`).then((res) => {
      setPackageBuffer(false);
      if (res.status === 200) {
        setAllPackage(res.data.allPackages);
        setUserId(res.data.userId);
      }
    });
  }, []);

  const handleModel = (data) => {
    setPackageId(data[0]);
    setPackagePrice(data[1]);
    setBasePrice(data[2]);
    // props.setModalShow(false);
    setModalShowPay(true);
  };

  const handleModelFree = (data) => {
    setModalShowPay(false);
    setPackageId(data);

    axios.post(`/api/user/free/wallet/store/${data}/${userId}`).then((res) => {
      if (res.data.status === 200) {
        swal("Welcome", res.data.message, "success");
      }
    });
  };

  useEffect(() => { }, [fanGroupInfo]);

  return (
    <>
      <div className="">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <div className="pak-header text-center col-md-12 px-2">
            <p>Select the perfect package for you</p>
          </div>
          <div className="text-center col-md-12">
            <p style={{ color: "#FFAA00" }}>
              You need{" "}
              <b className="bg-white text-dark px-2">
                {fanGroupInfo.club_points}
              </b>{" "}
              points but you have{" "}
              <b className="bg-secondary px-2 text-light">
                {walateInfo.club_points ? walateInfo.club_points : 0}
              </b>{" "}
              points buy package for continue
            </p>
            {packageBuffer && (
              <div class="spinner-border text-warning" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            )}
          </div>

          <Modal.Body>
            <div className="row">
              {allPackages.map((data) => (
                <div className="col-md-3 col-sm-12 package-bg my-5">
                  <div className="pak-b">
                    <div className="pa-header">
                      <p> {data?.title}</p>
                    </div>
                    <div className="package">
                      <p>
                        {" "}
                        {data.club_points === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Club Points : {data.club_points}
                      </p>
                      <p>
                        {" "}
                        {data.club_points === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Love Points : {data.love_points}
                      </p>
                      <p>
                        {data.auditions === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Auditions : {data.auditions}
                      </p>
                      <p>
                        {data.learning_session === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Learning Session : {data.learning_session}
                      </p>
                      <p>
                        {data.live_chats === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Live Chats : {data.live_chats}
                      </p>
                      <p>
                        {data.meetup === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Meetup Events : {data.meetup}
                      </p>
                      <p>
                        {data.greetings === 0 ? (
                          <i className="fa-solid fa-xmark packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        ) : (
                          <i className="fa-solid fa-check packageColor">
                            {" "}
                            &nbsp;
                          </i>
                        )}{" "}
                        Greetings : {data.greetings}
                      </p>
                    </div>
                    <div className="but-c">
                      <p>
                        <b className="dollar">
                          {paymentCountWithSymbol(data.price)}
                        </b>{" "}
                      </p>

                      {data.price === 0 ? (
                        <button
                          className="package-btn"
                          type="button"
                          onClick={() => handleModelFree(data.id)}
                        >
                          Free
                        </button>
                      ) : (
                        <button
                          className="package-btn"
                          type="button"
                          onClick={() =>
                            handleModel([
                              data?.id,
                              paymentCount(data?.price),
                              data?.price,
                            ])
                          }
                        >
                          Buy Now
                        </button>
                      )}

                      <MyVerticallyCenteredModal
                        show={modalShowPay}
                        onHide={() => setModalShowPay(false)}
                        event_id={packageId}
                        fee={packagePrice}
                        baseFee={baseFee}
                        event_type="package"
                        redirectTo="wallet"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default PackageModal;
